import React from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';
import ProxySummary from './summary/proxySummary';
import { ProxyLists } from './ProxyLists';

/**
 * @component ProxyRoutes
 * @description For storing internal page redirection inside API Summary Module
 */
const ProxyRoutes = () => {
     return (
          <div className="proxy">
               <Switch>
                    <Route exact path="/home/proxy" render={() => (<Redirect to="/home/proxy/list" />)} />
                    <Route exact path="/home/proxy/list" render={() => (<ProxyLists />)} />
                    <Route exact path="/home/proxy/:apiName" render={() => (<ProxySummary  />)} />
               </Switch>
          </div>
     );
};

export default withRouter(ProxyRoutes);